import { useQuery } from "@tanstack/react-query";
import api from "@/api/client";

// Reads admin-configurable "pick lists" (multi-choice fields) with graceful fallback
// to the app's built-in defaults while the query is loading or if a group is missing.
export function usePickLists() {
  const { data = [] } = useQuery({
    queryKey: ["pick-lists"],
    queryFn: () => api.get("/pick-lists").then((r) => r.data),
    staleTime: 60000,
  });
  const byKey = Object.fromEntries(data.map((g) => [g.field_key, g]));

  const toLabel = (v) => (v && typeof v === "object" ? v.label : v);

  const options = (fieldKey, fallback = {}) => {
    const g = byKey[fieldKey];
    if (g) return g.options;
    return Object.entries(fallback).map(([value, v]) => ({ value, label: toLabel(v) }));
  };

  const labelOf = (fieldKey, value, fallback = {}) => {
    const g = byKey[fieldKey];
    const opt = g?.options.find((o) => o.value === value);
    if (opt) return opt.label;
    if (fallback[value] !== undefined) return toLabel(fallback[value]);
    return value;
  };

  return { groups: data, byKey, options, labelOf };
}
